import { render, staticRenderFns } from "./OrderNamePopup.vue?vue&type=template&id=5b7c8aa6&"
import script from "./OrderNamePopup.vue?vue&type=script&lang=js&"
export * from "./OrderNamePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports